import { Box, Button, TextField, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { newPackageType } from "./functions";
import { VishcorpContext } from "Context";

export default function NewPackageType(props) {
  const { handleClose, organizationID, onRefresh } = props;
  const [newPackage, setNewPackage] = useState(undefined);
  const { orgSettings } = useContext(VishcorpContext);
  const onSubmit = async () => {
    if (newPackage?.name) {
      await newPackageType(
        organizationID,
        newPackage,
        orgSettings?.organizationTablePrefix
      );
      handleClose();
      onRefresh();
    }
  };
  return (
    <Box sx={{ display: "flex", height: "100%", flexDirection: "column" }}>
      {/* <Paper sx={{ flexGrow: 1 }}> */}
      <Typography variant="h5">{`New Package Type`}</Typography>
      <br />
      <div>
        <TextField
          fullWidth
          size="small"
          value={newPackage?.name}
          label="Name"
          variant="outlined"
          onChange={(e) => {
            setNewPackage((pre) => ({
              ...pre,
              name: e?.target?.value,
            }));
          }}
          style={{ width: "100%", marginBottom: 15 }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "colmn",
            // justifyContent: "space-between",
          }}
        >
          <Button
            sx={{ marginRight: 2 }}
            variant="contained"
            onClick={onSubmit}
          >
            Submit
          </Button>
          <Button variant="contained" onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </div>
    </Box>
  );
}
